const $ = jQuery.noConflict();
import 'slick-carousel';

const firstLoad = true;
let slidersInitialized = false;
const blogRelatedSliderObjects = [];
const blogRelatedBlocks = document.querySelectorAll(
	'.block-related[data-slider-on-mobile="true"]'
);

const initSliders = () => {
	if (!blogRelatedBlocks.length) {
		return;
	}
	blogRelatedBlocks.forEach((block, index) => {
		const sliderContainer = block.querySelector(
			'.block-related__post-grid'
		);
		if (!sliderContainer) {
			return;
		}
		// On first load setup the slider objects.
		if (firstLoad) {
			blogRelatedSliderObjects[index] = {
				container: sliderContainer,
				slider: null,
			};
		}
		if (window.innerWidth < 576 && !slidersInitialized) {
			blogRelatedSliderObjects[index].slider = $(sliderContainer).slick({
				arrows: false,
				dots: false,
				infinite: true,
				adaptiveHeight: false,
			});
		}
	});
	if (window.innerWidth < 576) {
		slidersInitialized = true;
	}
};

const destroySliders = () => {
	if (
		blogRelatedSliderObjects.length &&
		slidersInitialized &&
		window.innerWidth >= 576
	) {
		slidersInitialized = false;
		blogRelatedSliderObjects.forEach((slider) => {
			$(slider.container).slick('unslick');
		});
	}
};

const controller = {
	init() {
		initSliders();
	},
	loaded() {},
	resized() {
		if (window.innerWidth >= 576) {
			destroySliders();
		} else {
			initSliders();
		}
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
